import { defineEntityContract, type EntityByIdRequests, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import type {
  CreateLevelRequest,
  EditLevelRequest,
  LevelDeleteRequest,
  LevelRestoreRequest,
} from 'shared/domain/messages/level/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { LevelModel } from './types/model';

/**
 * Level events. Outcome payloads stay `unknown`: the HTTP queue sends `true`
 * after a create, delete or restore, the ids of the changed levels after an
 * edit and `{ error, messageId }` with a failure.
 */
export type LevelEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allLevels]: { hasAll?: boolean; items: LevelModel[] };
  [DomainMessagesTypes.uploadedEntity]: unknown;
  [DomainMessagesTypes.updatedEntity]: unknown;
  [DomainMessagesTypes.deletedEntity]: unknown;
};

/**
 * One level for the views that show it, and the level changes: each change
 * resolves once queued, its outcome follows as an event with its `uniqueId`.
 */
export type LevelRequests = EntityByIdRequests<LevelModel> & {
  create: { request: CreateLevelRequest; response: void };
  edit: { request: EditLevelRequest; response: void };
  remove: { request: LevelDeleteRequest; response: void };
  restore: { request: LevelRestoreRequest; response: void };
};

export const levelContract = defineEntityContract<LevelModel, LevelEvents, LevelRequests>('levelChannel', {
  collectionEvent: DomainMessagesTypes.allLevels,
});
